import { initializeHeader } from "./header";
import { loadProjectDataFromApi } from "../data/projectData";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { DEFAULT_PAGE_SIZE, UNDISPLAY_ITEM } from "../constant/applicationConstant";
/**
 * 案件情報リスト
 */
let projectData = [];
/**
 * 現在選択されている案件データ
 */
let currentProjectData = null;
/**
 * APIから特定の案件IDの詳細データを取得する関数
 */
async function loadProjectDetailFromApi(projectId) {
    try {
        // loadProjectDataFromApiを使用して重複を避ける
        const apiParam = {
            tenpoNo: "",
            tenpoName: "",
            zoCode: "",
            zoName: "",
            doCode: "",
            doName: "",
            ofcName: "",
            projectNo: projectId,
            businessType: "",
            programName: "",
            projectStatus: "",
            status: "",
            progressStatus: "",
            startDateFrom: "",
            startDateTo: "",
            page: 1,
            pageSize: 1,
            columnPattern: "equipment_detail" // 設備案件詳細パターン（individual_equipment_projectテーブルから全カラム取得）
        };
        const response = await loadProjectDataFromApi(apiParam);
        if (response.projects && response.projects.length > 0) {
            return response.projects[0];
        }
        else {
            console.warn(`案件ID ${projectId} のデータがAPIから取得できませんでした`);
            return null;
        }
    }
    catch (error) {
        console.error('API通信エラー:', error);
        return null;
    }
}
/**
 * 案件IDから案件データを取得する関数（後方互換性のため残す）
 */
function getProjectData(projectId) {
    return projectData.find(project => project.projectNo === projectId) || null;
}
/**
 * 日付フォーマット変換関数（YYYY/M/D → YYYY-MM-DD）
 */
function formatDateForInput(dateStr) {
    if (!dateStr)
        return "";
    // YYYY/M/D または YYYY/MM/DD 形式を YYYY-MM-DD に変換
    const parts = dateStr.split('/');
    if (parts.length === 3) {
        const year = parts[0];
        const month = parts[1].padStart(2, '0');
        const day = parts[2].padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return dateStr;
}
/**
 * 設備案件詳細画面のフィールドを更新する関数
 */
function updateIndividualEquipmentFields(project) {
    // 案件基本情報
    const setFieldValue = (id, value) => {
        const element = document.getElementById(id);
        if (element) {
            // UNDISPLAY_ITEMの場合は親要素を非表示にする
            if (value === UNDISPLAY_ITEM) {
                const parentElement = element.closest('.form-group') || element.parentElement;
                if (parentElement) {
                    parentElement.style.display = 'none';
                }
            }
            else {
                element.value = value;
            }
        }
    };
    const setDateFieldValue = (id, value) => {
        const element = document.getElementById(id);
        if (element) {
            // UNDISPLAY_ITEMの場合は親要素を非表示にする
            if (value === UNDISPLAY_ITEM) {
                const parentElement = element.closest('.form-group') || element.parentElement;
                if (parentElement) {
                    parentElement.style.display = 'none';
                }
            }
            else {
                // 値がある場合のみtype="date"に変更（空の場合はtype="text"のまま）
                if (value) {
                    element.type = 'date';
                }
                element.value = value;
            }
        }
    };
    // 案件基本情報
    setFieldValue('案件No', project.projectNo);
    setFieldValue('業務種別', project.businessType || '');
    setFieldValue('プログラム名', project.programName);
    setFieldValue('件名', project.projectName || '');
    setDateFieldValue('案件開始日', formatDateForInput(project.startDate || ''));
    setFieldValue('設備部担当者', project.equipdeptPerson || '');
    setFieldValue('管理部担当者', project.managedeptPerson || '');
    setFieldValue('建築部担当者', project.constdeptPerson || '');
    setFieldValue('申請区分', project.applicationType || '');
    setFieldValue('BOX内部', project.boxInternal || '');
    setFieldValue('BOX外部', project.boxExternal || '');
    setFieldValue('未確定確定', project.pendingOrDecision || '');
    setFieldValue('案件進捗', project.projectStatus);
    setFieldValue('設備進捗', project.equipmentProgress || '');
    setDateFieldValue('設備進捗更新日', formatDateForInput(project.equipmentProgressUpdateDate || ''));
    setDateFieldValue('設備案件完了日', formatDateForInput(project.equipmentProjectCompleteDate || ''));
    setFieldValue('案件中止理由', project.projectAbortReason || '');
    setFieldValue('設備案件進捗状況', project.progressStatus || '');
    setFieldValue('受発注ステータス', project.contractOrderStatus || '');
    setFieldValue('申請状況', project.requestState || '');
    // 店舗基本情報
    setFieldValue('ZO', project.zoName);
    setFieldValue('DO', project.doName);
    setFieldValue('店No', project.storeNo);
    setFieldValue('店名', project.storeName);
    setFieldValue('OFC', project.ofcName || '');
    setFieldValue('契約タイプ', project.contractType);
    setFieldValue('所有区分', project.ownershipType);
    setFieldValue('設備保守制度', project.equipMantePlanCont);
    setFieldValue('空調機保守制度', project.airConditioningMantePlanCont);
    setFieldValue('７カフェ保守制度', project.sevenCafeMantePlanCont);
    setFieldValue('フライヤー保守制度', project.fryerMantePlanCont);
    setFieldValue('食器洗浄機保守制度', project.dishwasherMantePlanCont);
    setFieldValue('スムージー保守制度', project.smoothieEquipMantePlanCont);
    setFieldValue('自動ドアメンテナンス', project.automaticDoorManteCont);
    setFieldValue('店頭看板保守制度', project.storefrontSignMantePlanCont);
    setFieldValue('サインポール保守制度', project.signPoleMantePlanCont);
    // 案件業者情報
    setFieldValue('ゴンドラ業者', project.gondolaVendor || '');
    setFieldValue('建築業者', project.constructionVendor || '');
    setFieldValue('冷設業者', project.coldequipVendor || '');
    // 店舗基本情報（店舗マスタ由来）
    setFieldValue('都道府県', project.prefecture || '');
    setFieldValue('住所漢字', project.address || '');
    setFieldValue('OFC電話番号', project.ofcMobileNumber || '');
    setDateFieldValue('開店年月日', formatDateForInput(project.openStoreDate || ''));
    setDateFieldValue('オリジナル開店年月日', formatDateForInput(project.originalOpenStoreDate || ''));
    setDateFieldValue('閉店年月日', formatDateForInput(project.closedStoreDate || ''));
    // 申請基本情報
    setDateFieldValue('Agile受付日', formatDateForInput(project.agileReceiptDate || ''));
    setDateFieldValue('Agile承認日', formatDateForInput(project.agileApproveDate || ''));
    setFieldValue('AgileID', project.agileId || '');
    setFieldValue('駐車場', project.parking || '');
    setFieldValue('営業時間', project.businessHours || '');
    setFieldValue('希望日程搬入', project.desiredDateIn || '');
    setFieldValue('希望日程搬出', project.desiredDateOut || '');
    setFieldValue('作業時間帯', project.workingHours || '');
    setFieldValue('時間外作業理由', project.overtimeWorkReason || '');
    setFieldValue('作業届提出期限', project.workNotificationLimit || '');
    setFieldValue('申請理由', project.requestReason || '');
    setFieldValue('理由詳細', project.reasonDetail || '');
    setFieldValue('特記事項', project.specialNotes || '');
    setFieldValue('単独or複合', project.singleOrComplex || '');
    // 現地調査・レイアウト関連
    setDateFieldValue('予定レイアウト作成依頼日', formatDateForInput(project.planLayoutRequestDate || ''));
    setDateFieldValue('現地調査予定日', formatDateForInput(project.fieldSurveyPlannedDate || ''));
    setDateFieldValue('現地調査実施日', formatDateForInput(project.fieldSurveyExecDate || ''));
    setDateFieldValue('現調後レイアウト提出日', formatDateForInput(project.fieldSurveyLayoutSubmitDate || ''));
    setDateFieldValue('予定レイアウトOP送付日', formatDateForInput(project.planLayoutOpSendDate || ''));
    setDateFieldValue('予定レイアウト承認日', formatDateForInput(project.planLayoutApprovalDate || ''));
    // ATM関連
    setDateFieldValue('必要資料格納日', formatDateForInput(project.needDataStorageDate || ''));
    setDateFieldValue('資料受領日', formatDateForInput(project.dataReceiptDate || ''));
    setFieldValue('資料不備有無', project.dataDefectState || '');
    setFieldValue('7BK可否判断', project.sevenBkPossibilityJudge || '');
    setDateFieldValue('7BKtoOFC連絡日', formatDateForInput(project.sevenBkOfcContactDate || ''));
    setDateFieldValue('ATM工事実施日', formatDateForInput(project.atmConstructionExecDate || ''));
    setFieldValue('費用負担', project.costCharge || '');
    setDateFieldValue('SEJ負担見積書受領', formatDateForInput(project.sejChargeEstimateReceiptDate || ''));
    setDateFieldValue('進捗設備to7BK', formatDateForInput(project.progressUpdateEquipdeptSevenBk || ''));
    setDateFieldValue('進捗7BKto設備', formatDateForInput(project.progressUpdateSevenBkEquipdept || ''));
    setFieldValue('ATM台数', project.atmCount || '');
    setFieldValue('ATM固定方法', project.atmFixationMethod || '');
    setFieldValue('ATM利用平均日数', project.atmUseAverageDays || '');
    setFieldValue('ATM移設理由費用負担', project.atmMovementReasonCostBurden || '');
    setFieldValue('ATM増設理由', project.atmExpansionReason || '');
    setFieldValue('移設対象機器', project.movementTargetMachine || '');
    setFieldValue('移設貸与申請', project.movementLoanEquipRequest || '');
    setFieldValue('ATM2台目貸与申請', project.atmTwoExpansionLoanEquipmentRequest || '');
    setFieldValue('ATM移設理由詳細', project.atmMovementReasonDetail || '');
    setFieldValue('ATM2台目理由詳細', project.atmTwoExpansionReasonDetail || '');
    setFieldValue('ATM2台目設置場所', project.atmTwoExpansionInstallationLocation || '');
    setFieldValue('ATM移設可否', project.atmMovementPossibility || '');
    setFieldValue('ATM増設可否', project.atmExpansionPossibility || '');
    setDateFieldValue('OFC連絡日7BK使用', formatDateForInput(project.ofcContactDate || ''));
    // 見積・費用申請関連
    setDateFieldValue('見積開始登録日', formatDateForInput(project.estimateStartDate || ''));
    setFieldValue('見積回数', project.quotationCnt != null ? String(project.quotationCnt) : '');
    setDateFieldValue('見積依頼日', formatDateForInput(project.quotationRequestDate || ''));
    setDateFieldValue('見積作成日', formatDateForInput(project.quotationCreateDate || ''));
    setDateFieldValue('見積確認日', formatDateForInput(project.quotationConfirmDate || ''));
    setDateFieldValue('見積申請日', formatDateForInput(project.quotationApplyDate || ''));
    setDateFieldValue('見積承認日M', formatDateForInput(project.quotationApprovedDateM || ''));
    setDateFieldValue('見積承認日GM', formatDateForInput(project.quotationApprovedDateGm || ''));
    setDateFieldValue('決裁開始登録日', formatDateForInput(project.approvalStartDate || ''));
    setFieldValue('費用申請書No', project.costClaimNo || '');
    setDateFieldValue('費用申請出力日', formatDateForInput(project.costClaimOutputDate || ''));
    setDateFieldValue('費用申請決裁登録日', formatDateForInput(project.costClaimApprovalRegisterDate || ''));
    setDateFieldValue('費用申請決裁日', formatDateForInput(project.costClaimApprovalDate || ''));
    // Aタイプ見積・発注関連
    setDateFieldValue('A_OFC案内日', formatDateForInput(project.aOfcGuideDate || ''));
    setFieldValue('A_費用承諾要否', project.aCostConsentFlg || '');
    setFieldValue('A_費用承諾ステータス', project.aCostConsentState || '');
    setDateFieldValue('A_費用承諾及び手配確認日', formatDateForInput(project.aCostConsentAndArrangementConfirmDate || ''));
    setDateFieldValue('A_工事予定日', formatDateForInput(project.aConstructionPlannedDate || ''));
    // 決裁関連
    setFieldValue('搬入稟議書番号', project.carryingInApprovalNo || '');
    setDateFieldValue('搬入稟議書決裁日', formatDateForInput(project.carryingInApprovalDate || ''));
    setFieldValue('搬出稟議書番号', project.carryingOutApprovalNo || '');
    setDateFieldValue('搬出稟議書決裁日', formatDateForInput(project.carryingOutApprovalDate || ''));
    // 貸主承諾関連
    setFieldValue('貸主承諾要否一次', project.lenderConsentRequiredInitialJudge || '');
    setFieldValue('承諾確認用施工内容', project.lendersConsentConfirmConstructionContent || '');
    setFieldValue('貸主承諾拒否', project.lendersConsentRejection || '');
    setDateFieldValue('承諾用資料格納日', formatDateForInput(project.lendersConsentDataStorageDate || ''));
    setDateFieldValue('貸主承諾依頼日', formatDateForInput(project.lendersConsentRequestDate || ''));
    setDateFieldValue('貸主承諾受付日', formatDateForInput(project.lendersConsentReceiptDate || ''));
    setDateFieldValue('貸主承諾貸主依頼日', formatDateForInput(project.lendersConsentLendersRequestDate || ''));
    setDateFieldValue('貸主承諾書回収日', formatDateForInput(project.lendersConsentFormCollectDate || ''));
    setFieldValue('貸主承諾ステータス', project.lendersConsentState || '');
    setFieldValue('貸主承諾要否', project.lendersConsentFlg || '');
    setFieldValue('既存店管理担当者名', project.inprogressDepartment || '');
    setFieldValue('貸主承諾通知判断', project.consentRequiredProcedureEtc || '');
    setFieldValue('コメント', project.comment || '');
    // 電力申請関連
    setFieldValue('電力申請要否', project.powerRequestFlg || '');
    setFieldValue('電力申請ステータス', project.powerRequestState || '');
    setFieldValue('電力区分', project.powerCategory || '');
    setFieldValue('低圧申請状況', project.lowVoltageRequestState || '');
    setDateFieldValue('電力申請資料提出日', formatDateForInput(project.powerRequestDataSubmitDate || ''));
    setDateFieldValue('電力申請完了日', formatDateForInput(project.powerRequestCompleteDate || ''));
    // 水道局申請関連
    setFieldValue('水道局申請ステータス', project.waterRequestCondition || '');
    setFieldValue('水道局申請必要要否', project.waterRequestNeedFlg || '');
    setFieldValue('水道局申請状況', project.waterRequestState || '');
    setDateFieldValue('水道局申請書類提出日', formatDateForInput(project.waterRequestDocumentSubmitDate || ''));
    setDateFieldValue('水道局申請完了日', formatDateForInput(project.waterRequestCompleteDate || ''));
    // 工事基本情報
    setFieldValue('作業工事届有無', project.workConstructionNotificationState || '');
    setDateFieldValue('作業工事届対応日', formatDateForInput(project.workConstructionNotificationResponseDate || ''));
    setDateFieldValue('日程調整入力日', formatDateForInput(project.carryingInScheduleAdjustInputDate || ''));
    setDateFieldValue('最終納品予定日', formatDateForInput(project.finalDeliveryScheduledDate || ''));
    setDateFieldValue('工事案内格納日', formatDateForInput(project.constructionGuideStorageDate || ''));
    setDateFieldValue('電源工事予定日', formatDateForInput(project.powerSupplyPlannedDate || ''));
    setDateFieldValue('設備工事予定日', formatDateForInput(project.equipmentSupplyPlannedDate || ''));
    setFieldValue('設備工事時間', project.equipmentSupplyTime || '');
    // 対応内容
    setFieldValue('新規貫通', project.newPenetrate || '');
    setFieldValue('室外機増設入替', project.outdoorUnitExpansionReplace || '');
    setFieldValue('垂壁吊戸', project.wallDoor || '');
    setFieldValue('防犯カメラ脱着', project.securityCameraDesorption || '');
    setFieldValue('エコキュート交換', project.ecocuteChange || '');
    setFieldValue('給湯機器対応', project.hotWaterEquipSupport || '');
    setFieldValue('OC基準台数', project.ocStandardNumber || '');
    setFieldValue('新規室外機馬力数', project.newOutdoorUnitPower || '');
    // 完了報告・検収関連
    setDateFieldValue('電源工事完了日', formatDateForInput(project.powerSupplyCompleteDate || ''));
    setDateFieldValue('設備施工完了日', formatDateForInput(project.equipmentConstructionCompleteDate || ''));
    setDateFieldValue('最終納品日', formatDateForInput(project.finalDeliveryDate || ''));
    setDateFieldValue('最終完了報告日', formatDateForInput(project.finalCompletionReportDate || ''));
    setDateFieldValue('最終完了報告承認日', formatDateForInput(project.finalCompletionReportApprovedDate || ''));
    setDateFieldValue('工事完了資料格納日', formatDateForInput(project.constructionCompleteDataStorageDate || ''));
    setFieldValue('作図要否一次', project.drawingRequiredInitialJudge || '');
    setFieldValue('作図要否', project.drawingFlg || '');
    setDateFieldValue('作図用資料格納日', formatDateForInput(project.drawingDataStorageDate || ''));
    setDateFieldValue('竣工図面格納日', formatDateForInput(project.completionDrawingStorageDate || ''));
}
/**
 * 戻るボタンのイベントリスナーを設定する関数
 */
function setBackButton() {
    const backButton = document.getElementById('backButton');
    if (backButton) {
        backButton.addEventListener('click', (e) => {
            e.preventDefault();
            // ルーターを使用して案件一覧画面に戻る
            navigate('/');
        });
    }
}
/**
 * 設備案件詳細の初期化
 */
export const initializeIndividualEquipment = async (projectId) => {
    const subContentsElement = document.getElementById('subContents');
    const subContents = await getHtml("/individualEquipment.html");
    if (subContents) {
        // 設備案件詳細画面のHTMLを生成
        subContentsElement.innerHTML = subContents;
        // DOMが更新されるまで少し待ってからヘッダーを初期化
        setTimeout(() => {
            initializeHeader();
        }, 10);
    }
    else {
        console.error('設備案件詳細HTMLの読み込みに失敗しました');
    }
    // 案件IDが指定されている場合、APIから案件データを取得して表示
    if (projectId) {
        // APIから案件詳細データを取得
        currentProjectData = await loadProjectDetailFromApi(projectId);
        if (currentProjectData) {
            // フィールドを更新するために少し遅延を設ける
            setTimeout(() => {
                updateIndividualEquipmentFields(currentProjectData);
            }, 100);
        }
        else {
            console.error(`案件ID ${projectId} のデータがAPIから取得できませんでした`);
            // フォールバック: 既存のプロジェクトデータから検索
            if (projectData.length === 0) {
                const apiParam = {
                    tenpoNo: "",
                    tenpoName: "",
                    zoCode: "",
                    zoName: "",
                    doCode: "",
                    doName: "",
                    ofcName: "",
                    projectNo: "",
                    businessType: "",
                    programName: "",
                    projectStatus: "",
                    status: "",
                    progressStatus: "",
                    startDateFrom: "",
                    startDateTo: "",
                    page: 1,
                    pageSize: DEFAULT_PAGE_SIZE,
                    columnPattern: "equipment_detail" // 設備案件詳細画面用（individual_equipment_projectから全カラム取得）
                };
                const response = await loadProjectDataFromApi(apiParam);
                projectData = response.projects;
            }
            currentProjectData = getProjectData(projectId);
            if (currentProjectData) {
                setTimeout(() => {
                    updateIndividualEquipmentFields(currentProjectData);
                }, 100);
            }
            else {
                console.error(`案件ID ${projectId} に対応するデータが見つかりません`);
            }
        }
    }
    // 戻るボタンにイベントリスナーを設定
    setBackButton();
};
